import TableAccordion from "../../../../Components/TableAccordion";
import { TextEditor } from "../../../../Components/TextEditor";
import styles from "../../creditScore.module.scss";

interface ICreditScoreCommments {
  defaultValue: string;
  handleChange: any;
  readOnly?: boolean;
}

const RepaymentStructureComments = ({
  defaultValue,
  handleChange,
  readOnly,
}: ICreditScoreCommments) => {
  return (
    <div className={styles.CreditScoreComments}>
      <TableAccordion
        title={<span className={styles.Title}>REPAYMENT COMMENTS</span>}
        isDefaultOpen
      >
        <TextEditor
          onChange={handleChange}
          defaultValue={defaultValue}
          readOnly={readOnly}
        />
      </TableAccordion>
    </div>
  );
};

export default RepaymentStructureComments;
